import { render, staticRenderFns } from "./exit.vue?vue&type=template&id=6f972582&"
import script from "./exit.vue?vue&type=script&lang=js&"
export * from "./exit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports